import { Printer } from "lucide-react";
import { QRCodeCanvas } from "qrcode.react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const QrShareDialog = ({ open, onOpenChange, url, title, subtitle }) => {
  const printQr = () => {
    const canvas = document.querySelector("#qr-share-canvas canvas");
    if (!canvas) return;
    const dataUrl = canvas.toDataURL("image/png");
    const safeTitle = (title || "").replace(/[<>&"]/g, "");
    const safeSubtitle = (subtitle || "The Archive · Scan to open").replace(/[<>&"]/g, "");
    const win = window.open("", "_blank");
    if (!win) return;
    win.document.write(`<!DOCTYPE html><html><head><title>${safeTitle} — QR code</title></head>
      <body style="text-align:center;font-family:Georgia,serif;padding:48px">
        <h1 style="margin:0 0 4px;font-size:30px;max-width:640px;display:inline-block">${safeTitle}</h1>
        <p style="color:#555;margin:6px 0 28px;font-family:Arial,sans-serif">${safeSubtitle}</p>
        <img src="${dataUrl}" style="width:360px;height:360px" alt="QR code"/>
        <p style="color:#888;font-size:12px;font-family:Arial,sans-serif;word-break:break-all">${url}</p>
        <script>window.onload = function(){ window.print(); }</script>
      </body></html>`);
    win.document.close();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="qr-share-dialog">
        <DialogHeader>
          <DialogTitle className="line-clamp-2">Scan to open “{title}”</DialogTitle>
        </DialogHeader>
        <div id="qr-share-canvas" className="flex justify-center py-4">
          <QRCodeCanvas value={url} size={280} level="M" includeMargin />
        </div>
        <p className="text-[11px] text-slate-400 text-center break-all -mt-2">{url}</p>
        <div className="flex justify-end gap-2 mt-2">
          <Button type="button" variant="outline" size="sm" onClick={() => onOpenChange(false)}>
            Close
          </Button>
          <Button
            type="button"
            size="sm"
            onClick={printQr}
            className="bg-orange-600 hover:bg-orange-700 text-white"
            data-testid="qr-share-print"
          >
            <Printer className="w-4 h-4 mr-1.5" /> Print QR
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
